export const TITLE = 'CRM';
export const TITLE_VOX = 'CRM - VOX';

export const ROUTE = {
  MAIN: '/',
  CALLS: '/calls',
  TICKETS: '/tickets',
  MANAGER_EMAILS: '/manager_emails',
  STATSTIC: '/statistic',
  TASKS: '/tasks',
};

export const PATH = {
  MAIN: '/',
  CALLS: `${ROUTE.CALLS}/:call_id?`,
  TICKETS: `${ROUTE.TICKETS}/:ticket_id?/:chain_id?`,
  MANAGER_EMAILS: `${ROUTE.MANAGER_EMAILS}/:email_id?`,
  STATSTIC: ROUTE.STATSTIC,
  TASKS: `${ROUTE.TASKS}/:task_id?`,
};

export const TITLES = {
  [ROUTE.MAIN]: 'Главная',
  [ROUTE.CALLS]: 'Звонки',
  [ROUTE.TICKETS]: 'Тикеты',
  [ROUTE.MANAGER_EMAILS]: 'E-mail',
  [ROUTE.STATSTIC]: 'Статистика',
  [ROUTE.TASKS]: 'Задачи',
};

export const PAGES = {
  MAIN: 'Main',
  CALLS: 'Calls',
  TICKETS: 'Tickets',
  MANAGER_EMAILS: 'ManagerEmails',
  STATSTIC: 'Statistic',
  TASKS: 'Tasks',
};
